/**
 * Ids of the columns the table adds on its own (never declared by a call
 * site). They share a prefix so features that only care about the operator's
 * data columns can skip them in one check (see `isInternalColumnId`).
 */
export const INTERNAL_COLUMN_PREFIX = "__"
export const SELECTION_COLUMN_ID = "__select"
export const ACTIONS_COLUMN_ID = "__actions"
/** Absorbs the remaining table width so fixed columns keep their exact sizes. */
export const SPACER_COLUMN_ID = "__spacer"
/**
 * What `Table.Search` registers as its target when it writes the table's
 * global filter rather than a column's (see `registerSearch`). Shares the
 * internal prefix so it can never collide with a column id.
 */
export const GLOBAL_SEARCH_TARGET = "__globalSearch"
